<template>
  <div>
    <div v-for="(item, index) in detailedList" :key="index">
      <p class="user-info-style">
        <label>配送至：</label>
        <span>{{ item.rfullAddress }} {{ item.rreceiveUserName }} {{ item.rreceiveTel }}</span>
      </p>

      <!-- <div
        v-for="(childI, childIndex) in item.contractProductList"
        :key="childIndex"
        class="table-container"
      > -->
      <el-table
        v-if="item.contractProductList.length"
        :data="item.contractProductList"
        border
        style="width: 100%"
        :summary-method="getSummaries"
        show-summary
      >
        <el-table-column type="index" width="70" label="序号" align="left" fixed="left" />
        <el-table-column prop="rproductCode" label="销售产品代码" align="left" />
        <el-table-column prop="rproductInvoiceName" label="商品名称" align="left" fixed="left" />
        <el-table-column prop="rproductName" label="规格型号" align="left" />
        <el-table-column prop="rproductNum" label="数量" align="left" width="70" />
        <el-table-column prop="rmaterialUnit" label="单位" align="left" width="80" />
        <el-table-column prop="rafterSplitPrice" label="单价" align="right" header-align="left" />
        <el-table-column prop="rproductPriceAdd" label="订单金额" align="right" header-align="left" />
        <el-table-column prop="rbeforeSplitPrice" label="拆分前单价" align="right" header-align="left" width="90" />
        <el-table-column prop="rproductActualPriceAdd" label="实际结算金额" align="right" header-align="left" width="100" />
        <el-table-column prop="risBuyPsc" label="是否购买PSC" align="left" />
        <el-table-column prop="rexpectedDeliveryDate" label="期望发货日期" align="left">
          <template v-slot="{row}">
            {{ row.rexpectedDeliveryDate && row.rexpectedDeliveryDate.substr(0,11) }}
          </template>
        </el-table-column>
        <el-table-column prop="taxName" label="税收分类名称" align="left" />
        <el-table-column prop="taxRate" label="税率" align="right" header-align="left" width="70px" />
        <el-table-column prop="" label="服务备注" align="left" />
      </el-table>
      <!-- </div> -->
    </div>
  </div>
</template>
<script>
import { getChangeContractInfo } from '@/API';
import { MathAdd } from '@/libs/util';
export default {
  props: {
    initInfo: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      detailedList: [],
      loading: false,
      exportLoading: false
    };
  },

  mounted () {
    this.initData();
  },

  methods: {
    initData (val) {
      if (!val?.contractId) return;
      this.loading = true;
      getChangeContractInfo({
        reContractId: val.contractId || ''
      }).then((res) => {
        const { status, data } = res.data;
        if (status === '200') {
          this.detailedList = data;
        }
        this.loading = false;
      });
    },

    // 合计
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.productNum('rproductNum');
          return;
        }
        if (column.label === '订单金额') {
          sums[index] = this.productNum('rproductPriceAdd');
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = this.productNum('rproductActualPriceAdd');
        }
      });
      return sums;
    },

    productNum (key) {
      let cont = 0;
      (this.detailedList[0] || []).contractProductList.forEach((item) => {
        cont = MathAdd(cont, item[key]);
      });
      // cont = Number(cont).toFixed(2);
      return cont || 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.user-info-style, .table-container{
  margin-bottom: 12px;
}
</style>
